import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Mail } from "lucide-react";
import { toast } from "sonner";

export default function AdminDripCard() {
  const [seq, setSeq] = useState({ free: [], paid: [] });

  useEffect(() => {
    api.get("/admin/drip/sequences").then((r) => setSeq(r.data)).catch(() => { /* noop */ });
  }, []);

  const sendTest = async (key) => {
    try {
      await api.post("/admin/drip/send-test", { key });
      toast.success("Test sent to your inbox");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not send");
    }
  };

  const runNow = async () => {
    if (!window.confirm("Run the drip job NOW for all users? Sends any due emails immediately.")) return;
    try {
      const r = await api.post("/admin/drip/run-now");
      toast.success(`Sent ${r.data.sent} email(s)`);
    } catch (err) {
      toast.error("Drip run failed");
    }
  };

  return (
    <div className="hc-card p-6" data-testid="admin-drip-card">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
        <h3 className="font-display text-xl flex items-center gap-2"><Mail className="w-5 h-5 text-[#3A5A4A]" /> Drip schedule</h3>
        <Button onClick={runNow} variant="outline" className="rounded-full border-[#EBE5DF] text-sm" data-testid="drip-run-now">Run drip now</Button>
      </div>
      <p className="text-sm text-[#7A736E] mb-5">
        Sends daily at 14:00 UTC. Edit copy in the Templates tab. Click any subject to send yourself a test copy with tracking.
      </p>
      {[{ key: "free", label: "Free sequence" }, { key: "paid", label: "Premium sequence" }].map((s) => (
        <div key={s.key} className="mb-4">
          <p className="text-xs uppercase tracking-wider text-[#7A736E] mb-2">{s.label} ({(seq[s.key] || []).length} emails)</p>
          <div className="space-y-1">
            {(seq[s.key] || []).map((e) => (
              <button key={e.key} onClick={() => sendTest(e.key)} className="w-full text-left flex items-center justify-between gap-3 px-3 py-2 rounded-lg hover:bg-[#F3EFEA] text-sm transition" data-testid={`drip-test-${e.key}`}>
                <span className="flex items-center gap-3 min-w-0">
                  <span className="text-xs text-[#7A736E] w-12 flex-shrink-0">Day {e.day}</span>
                  <span className="truncate">{e.subject}</span>
                </span>
                <span className="text-xs text-[#3A5A4A] hover:underline flex-shrink-0">Test →</span>
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
